export const isEeManager = (grant: string) => grant === 'EE manager';

export const isMillManager = (grant: string) => grant === 'Mill manager';

export const isManagerRole = (grant: string) => isEeManager(grant) || isMillManager(grant);

export const isOperationSustainability = (grant: string) => grant === 'Operational Sustainability';

export const isManagement = (grant: string) => grant === 'Management';

export const isAdminSuperUser = (grant: string) => grant === 'Admins & super users';

export const isDivisionUser = (grant: string) => grant === 'WP division users';

export const canUpdateFigures = (grant: string) => isEeManager(grant);

export const canSubmitTarget = (grant: string) =>
  isDivisionUser(grant) ||
  isOperationSustainability(grant) ||
  isEeManager(grant) ||
  isMillManager(grant) ||
  isManagement(grant) ||
  isAdminSuperUser(grant);

// export const canSubmitDivisionalTarget = (grant: string) => false;

export const canApproveTarget = (grant: string) => isMillManager(grant) || isAdminSuperUser(grant);

// export const canApproveDivisionalTarget = (grant: string) => false;
